import { useEffect, useState } from "react"
import "./completions.css"
import QuestionSD from "./questions/QuestionSD"
import QuestionQA from "./questions/QuestionQA"
import QuestionPD from "./questions/QuestionPD"
import QuestionST from "./questions/QuestionST"
import QuestionC from "./questions/QuestionC"
import AudioPlayer from "react-h5-audio-player"
import "react-h5-audio-player/lib/styles.css"
import QuestionCE from "./questions/QuestionCE"
import { useApi } from "../../hooks/useApi"

const CompletedLesson = ({ lesson }) => {
  const [question, setQuestion] = useState(null)
  const [category, setCategory] = useState("")
  const [lessonType, setLessonType] = useState("")
  const [lessonNumber, setLessonNumber] = useState(lesson.lessonNumber)

  const { fetchData, isLoading, error } = useApi()

  useEffect(() => {
    const determineLessonType = () => {
      switch (lesson.type) {
        case "Sentence Dictation":
          setCategory("listening")
          setLessonType("sentence-dictation")
          break
        case "Question Answer":
          setCategory("listening")
          setLessonType("qa")
          break
        case "Picture Description":
          setCategory("writing")
          setLessonType("picturedescription")
          break
        case "Comprehension":
          setCategory("reading")
          setLessonType("comprehension")
          break
        case "Storytelling":
          setCategory("speaking")
          setLessonType("storytelling")
          break
        case "Conversation Exchange":
          setCategory("speaking")
          setLessonType("conversation-exchange")
          break
        default:
          break
      }
    }

    const fetchLessonData = async () => {
      try {
        determineLessonType()
        if (category && lessonType && lessonNumber) {
          const data = await fetchData(`/lessons/${category}/${lessonType}/${lessonNumber}`)
          setQuestion(data)
        }
      } catch (error) {
        console.error("Error fetching lesson data:", error)
      }
    }

    fetchLessonData()
  }, [category, lessonType, lessonNumber, lesson.type, fetchData])

  if (isLoading) {
    return <div>Loading...</div>
  }

  if (error) {
    return <div>Error: {error.message}</div>
  }

  if (!question) {
    return <div>No lesson data available</div>
  }

  return (
    <div className="container-completed-lessons">
      <div className="completed-lesson-main">
        <div className="completed-lesson-type">
          <h4>{lesson.type}</h4>
        </div>
        <div className="completed-lesson-question">
          {lesson.type === "Sentence Dictation" && <QuestionSD lesson={question} />}
          {lesson.type === "Question Answer" && <QuestionQA lesson={question} />}
          {lesson.type === "Storytelling" && <QuestionST lesson={question} />}
          {lesson.type === "Comprehension" && <QuestionC lesson={question} />}
          {lesson.type === "Picture Description" && <QuestionPD lesson={question} />}
          {lesson.type === "Conversation Exchange" && <QuestionCE lesson={question} />}
        </div>
        {["Sentence Dictation", "Comprehension", "Picture Description"].includes(lesson.type) && (
          <div className="completed-lesson-answer">
            <h4>
              Answers: <span>{lesson.answers}</span>
            </h4>
          </div>
        )}
        {["Storytelling"].includes(lesson.type) && (
          <div className="completed-lesson-answer">
            <AudioPlayer src={lesson.audioFilePath || "/placeholder.mp3"} />
          </div>
        )}
        {["Conversation Exchange"].includes(lesson.type) && (
          <div className="completed-lesson-answer">
            <AudioPlayer src={lesson.audioFilePath1 || "/placeholder.mp3"} />
            <hr />
            <AudioPlayer src={lesson.audioFilePath2 || "/placeholder.mp3"} />
            <hr />
            <AudioPlayer src={lesson.audioFilePath3 || "/placeholder.mp3"} />
          </div>
        )}
        {["Question Answer"].includes(lesson.type) && (
          <div className="completed-lesson-answer">
            <h4>
              Answers 1: <span>{lesson.answers[0]}</span>
            </h4>
            <h4>
              Answers 2: <span>{lesson.answers[1]}</span>
            </h4>
            <h4>
              Answers 3: <span>{lesson.answers[2]}</span>
            </h4>
          </div>
        )}
      </div>
    </div>
  )
}

export default CompletedLesson

